export default {
  popularPlanAPiResponse: {},
  popularPlanFailureAPiResponse: {},
  popularPlanMockResponse: {},
  selectedPlans: {},
  displayPopularPerkList: {},
};
